import { ACCEPTED, AWAITING_ACTION, CANCELLED, DECLINED } from "../variables";
import { useBookingData } from "../context/BookingContext";


const QuoteAcceptanceControl = ({ acceptCallback, declineCallback }) => {

    const { booking } = useBookingData();

    const bookingStatus = booking?.bookingStatus;
    const paid = booking?.paid || false;

    switch(bookingStatus) {
        case ACCEPTED:
            return (
                <div className="h-16 relative w-3/4 mx-auto pt-2">
                    <div className="text-center text-gray-700">
                        {paid ? <div>This booking has been paid</div> : <div>This booking has been accepted</div>}
                    </div>
                </div>
            )
        case CANCELLED:
            return (
                <div className="h-16 relative w-3/4 mx-auto pt-2">
                    <div className="text-center text-gray-700">
                        <div>This booking has been cancelled</div>
                    </div>
                </div>
            )
        case AWAITING_ACTION:
        case DECLINED:
            return (
                <div className="h-16 relative w-3/4 mx-auto pt-2">
                    <div className="absolute right-0">
                        <button className="btn-blue btn-blue-active" onClick={acceptCallback}>
                            Accept
                            </button>
                        <button className="btn-blue btn-blue-active" onClick={declineCallback}>
                            Decline
                            </button>
                    </div>
                </div>
            )
        default:
            return (<div>error in fetched data</div>)

    }
}

export default QuoteAcceptanceControl;
